import { render, staticRenderFns } from "./menuManageDetail.vue?vue&type=template&id=79bf997c&scoped=true&"
import script from "./menuManageDetail.vue?vue&type=script&lang=js&"
export * from "./menuManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf997c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bf997c')) {
      api.createRecord('79bf997c', component.options)
    } else {
      api.reload('79bf997c', component.options)
    }
    module.hot.accept("./menuManageDetail.vue?vue&type=template&id=79bf997c&scoped=true&", function () {
      api.rerender('79bf997c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/menuManage/menuManageDetail.vue"
export default component.exports